/*
 * @Author: xiaolong.xu
 * @Date: 2023-02-13 17:04:33
 * @LastEditors: 最后编辑
 * @LastEditTime: 2023-03-14 14:59:02
 * @Description: ；路由常量
 */
export const WORKS_SIDER_MENUS = [
  {
    label: '我的作品',
    value: '/works',
    icon: 'icon-wodezuopin',
  },
  {
    label: '草稿箱',
    value: '/draft',
    icon: 'icon-wodecaogao',
  },
]

export const WORKS_ROUTE_MAP = WORKS_SIDER_MENUS.map(i => i.value)

export const MEDIA_SIDER_MENUS = [
  {
    label: '创意推送',
    translateKey: 'header:t24',
    value: '/media/creative',
    icon: 'icon-chuangyituisong',
    code: 'MEDIA_WORKS_PUSH',
  },
  {
    label: '授权管理',
    translateKey: 'header:t25',
    value: '/media/authorization',
    icon: 'icon-meitishouquan',
    code: 'MEDIA_AUTHORIZATION',
  },
  {
    label: '频道管理',
    translateKey: 'header:t26',
    value: '/media/channel',
    icon: 'iconjichuxinxi',
    code: 'MEDIA_CHANNEL',
  },
  {
    label: '推送记录',
    translateKey: 'header:t27',
    value: '/media/distribution',
    icon: 'iconjichuxinxi',
    code: 'MEDIA_DISTRIBUTION_RECORDS',
  },
]

export const MEDIA_ROUTE_MAP = MEDIA_SIDER_MENUS.map(i => i.value)

// 数据中心
export const DATA_SIDER_MENUS = [
  {
    label: '创意诊断',
    translateKey: 'header:t28',
    value: '/data/diagnosis',
    icon: 'icon-icon_cyzd',
    code: 'DATA_DIAGNOSIS',
  },
  {
    label: '创意分析',
    translateKey: 'header:t29',
    value: '/data/analyse',
    icon: 'icon-icon_cyfx',
    code: 'DATA_ANALYSIS',
  },
  {
    label: '投放分析',
    translateKey: 'header:t30',
    value: '/data/push',
    icon: 'icon-icon_wdtf',
    code: 'DATA_PUSH',
  },
]

export const DATA_ROUTE_MAP = DATA_SIDER_MENUS.map(i => i.value)

// 财务管理
export const WALLET_SIDER_MENUS = [
  {
    label: '财务记录',
    translateKey: 'header:t31',
    value: '/finance/record',
    icon: 'icon-tuisongjilu',
  },
]

export const WALLET_ROUTE_MAP = WALLET_SIDER_MENUS.map(i => i.value)

// 企业管理
export const MANAGEMENT_SIDER_MENUS: any[] = [
  {
    label: '基础信息',
    translateKey: 'header:t32',
    value: '/corporation/info',
    icon: 'icon-jichuxinxi',
    code: 'MANAGEMENT_INFO',
  },
  {
    label: '团队与员工',
    translateKey: 'header:t33',
    value: '/corporation/department',
    icon: 'icon-bumenyuyuangong',
    code: 'MANAGEMENT_DEPARTMENT',
  },
  {
    label: '角色与权限',
    translateKey: 'header:t34',
    value: '/corporation/roles',
    icon: 'icon-bumenyuyuangong',
    code: 'MANAGEMENT_ROLES',
  },
  {
    label: '财务记录',
    translateKey: 'header:t35',
    value: '/corporation/finance',
    icon: 'icon-tuisongjilu',
    code: 'MANAGEMENT_WALLET',
  },
]

/**
 * passport个人用户(非个人主体)、sso登录用户限制访问页面
 */
// export const UN_AUTH_PAGE_PERSONAL: any[] =  MANAGEMENT_SIDER_MENUS.concat([
// {
//   label: '认证选择',
//   value: '/certification/channel'
// },
// {
//   label: '企业认证',
//   value: '/certification/corporation',
// },
// {
//   label: '企业认证详情',
//   value: '/certification/corporation/detail',
// },
// {
//   label: '个人认证',
//   value: '/certification/personal',
// },
// {
//   label: '个人认证详情',
//   value: '/certification/personal/detail',
// },
// ])

export const MANAGEMENT_ROUTE_MAP = MANAGEMENT_SIDER_MENUS.map(i => i.value)
